import styled from "styled-components";

export const Container = styled.section`
  padding: 8rem 10%;
  background-color: ${(props) => props.theme.colors.GREY_1};
  min-height: 50rem;
  width: 65rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 4rem;
  }

  button {
    font-size: 2.6rem;
  }
`;

export const PaymentDetailsContainer = styled.div`
  margin: 10rem;
  font-size: 3rem;
  width: 100%;

  .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;
